import {put, takeEvery, select} from 'redux-saga/effects';
import {
  getOrderRefundData,
  updateOrderRefund
} from 'helpers/services/api/ordersV2';
import {
  CHANGE_STATUS_CONFIRMATION_MODAL,
  CHANGE_STATUS_CREATE_MODAL,
  GET_DATA_FOR_REFUND,
  GET_DATA_FOR_REFUND_SUCCESS,
  SET_REFUND_LOADING,
  UPDATE_REFUND_DATA
} from 'store/ordersV2/orderRefund/action';
import {CHANGE_REFUNDS_HISTORY} from 'store/ordersV2/orderList/action';
import {CHANGE_REFUNDS_ACTIVE} from 'store/global/ordersV2/action';
import {GET_ORDER, ORDER_UNMOUNT} from 'store/ordersV2/orderDetails/action';

export function* updateRefund({payload: {data, orderType}}) {
  try {
    const {orderId} = yield select(
      (state) => state.refundV2Reducer.dataForRefund
    );
    const order = yield select((state) => state.orderDetailsV2Reducer.order);
    const locationId = yield select((state) => state.user.locationId);

    const refunds = yield updateOrderRefund(orderId || order?.id, {
      ...data,
      locationId
    });
    if (orderType === 'history') {
      yield put(CHANGE_REFUNDS_HISTORY(refunds?.data));
    } else {
      yield put(CHANGE_REFUNDS_ACTIVE(refunds?.data));
    }
    if (refunds) {
      yield put(CHANGE_STATUS_CREATE_MODAL(false));
      yield put(CHANGE_STATUS_CONFIRMATION_MODAL(true));
      yield put(SET_REFUND_LOADING(false));
    }
  } catch (error) {
    yield put(CHANGE_STATUS_CREATE_MODAL(false));
    yield put(SET_REFUND_LOADING(false));
    yield put(CHANGE_STATUS_CONFIRMATION_MODAL(true));
    yield put(ORDER_UNMOUNT());
    console.log('SAGA ERROR', error);
  }
}

function* getRefundData({payload: {orderId}}) {
  try {
    const {data} = yield getOrderRefundData(orderId);
    if (data) {
      yield put(GET_DATA_FOR_REFUND_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

function* orderRefundSaga() {
  yield takeEvery(UPDATE_REFUND_DATA, updateRefund);
  yield takeEvery(GET_DATA_FOR_REFUND, getRefundData);
}

export default orderRefundSaga;
